import React from 'react';
import AboutPageHero from '../pages/about-us/AboutPageHero';
import OurStory from '../pages/about-us/OurStory';
import ServicePromo from '../pages/about-us/ServicePromo';
import PageMeta from '../components/common/PageMeta';
import CtaTwo from '../components/cta/CtaTwo';
import FeatureImgThree from '../pages/about-us/FeatureImgThree';
import Team from '../components/team/Team';
import TestimonialTwo from '../components/testimonial/TestimonialTwo';
import Navbar from '../layout/Header/Navbar';
import Layout from '../layout/Layout';
import Footer from "../components/Home/Footer";

const AboutUs = () => {
  return (
    <Layout>
      <PageMeta title='Sunlex' />
      <Navbar classOption='navbar-light' />
      <AboutPageHero />
      <OurStory />
      <FeatureImgThree />
      <Footer/>
    </Layout>
  );
};

export default AboutUs;
